import React from "react";
import classNames from "classnames";

export function Icon({ className, color, icon, size = 16 }) {

    return (
        <>
            {
                React.createElement(icon, {
                    className: className,
                    width: size,
                    height: size
                })
            }
        </>
    );
}

export function IconText({ children, className, color, icon, size, spin }) {
    const classes = classNames(className, 'icon-text', 'is-align-items-center');

    const iconClasses = classNames({
        'spin': spin
    });

    return (
        <span className={ classes }>
            <span className="icon">
                <Icon className={ iconClasses } color={ color } icon={ icon } size={ size }/>
            </span>
            <span>
                { children }
            </span>
        </span>
    )
}